import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalService } from '../../../service/global.service';
import { CommonModule } from '@angular/common';
import { HttpService } from '../../../service/http.service';
declare var Swiper: any

@Component({
  selector: 'app-more-services',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './more-services.component.html',
  styleUrl: './more-services.component.scss'
})
export class MoreServicesComponent {

  openCheckoutPage: boolean = false;
  openPaymentPage: boolean = false;
  constructor(private _homeService: HttpService, private router: Router,
    private _router: ActivatedRoute,
    public gS: GlobalService) {

  }
  productData: Array<any> = [];
  initMoreServiceSwiper() {
    var swiper = new Swiper(".moreServiceSwiper_new", {
      // slidesPerView: 4,
      spaceBetween: 16,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      on: {
        init: () => {
          // const swiperEl = document.getElementById('more_services');
          // swiperEl?.classList.remove('swiper-wrapper-hidden');
        }
      },
      breakpoints: {
        640: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 4,
        },
      },
    });
  }
  async ngOnInit() {
    await this.getProductData().then((res: any) => {
      console.log(res, "product_data");
      setTimeout(() => {
        this.initMoreServiceSwiper();
      }, 0);
    });
  }
  getProductData() {
    return new Promise<Array<any>>((resolve) => {
      this._homeService.getAllProductsByCategory(this.gS.userData?.id ? this.gS.userData?.id : 0).subscribe((data: any) => {
        if (data?.data) {
          let response = data?.data?.pageData;
          if (response) {
            this.productData = response.flatMap((item: any) => item?.productList);
          }
        }
        resolve(this.productData);
      }, (error) => {
        console.log(error);
      });
    })
  }
  navigateToProduct(item: any) {
    this.openCheckoutPage = false;
    this.openPaymentPage = false;
    this.router.navigate(['/products', item?.productTypeSlug, item?.productUrl]);
  }
}
